var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52757b"
    },
    d: "M167.51,181.94c12.14,10.32,23.05,22.01,32.49,34.85c9.38-12.76,20.2-24.38,32.25-34.65V91.42h27.99 l-30.17-45.71L199.89,0l-30.18,45.71l-30.18,45.71h27.99V181.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52757b"
    },
    d: "M113.42,233.33c10.3,7.76,19.42,16.98,27.06,27.37c13.22,18.26,18.06,35.46,20.94,45.74 c0.25,0.9,0.5,1.79,0.74,2.69c1.39-7.65,3.1-15.28,5.19-22.74c5.68-21.83,14.82-42.6,27.07-61.54l-1.51-2.12 c-11.41-15.6-25.05-29.44-40.47-41.08c-15.29-11.56-32.18-20.84-50.12-27.57l3.63-8.51l6.94-16.19l-53.12,9.72L6.6,148.72 l29.76,45.06l29.78,45.11l7.12-16.67l3.64-8.53C90.01,218.32,102.33,224.94,113.42,233.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52757b"
    },
    d: "M340.26,139.04l-53.12-9.72l6.94,16.19l3.62,8.51c-36.23,13.57-67.71,37.42-90.58,68.62 c-19.97,27.67-27.35,53.74-30.86,66.24c-6.04,21.5-8.94,43.76-8.61,66.08h-0.14V400h64.74v-45.03h0.1v-0.9l0,0 c-0.24-16.1,1.85-32.15,6.19-47.65c2.89-10.28,7.72-27.47,20.94-45.74c7.65-10.39,16.78-19.6,27.1-27.35 c11.1-8.38,23.43-14.99,36.56-19.6l3.64,8.53l7.08,16.67l29.76-45.07l29.78-45.06L340.26,139.04z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconGreen);
export default __webpack_public_path__ + "static/media/share-icon-green.9ed7bedb4358ad90df2c194f2efdc3af.svg";
export { ForwardRef as ReactComponent };